let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iLRNr")).then(() => parcelRequire('2zsHZ'));